export const enum OnboardingVariant {
  Control = 'control',
  Rollout = 'rollout',
}
